import { type RequestApi } from '../api/types'

/** Схемы работы продавца: заявка уходит фулфилментам, которые работают так же. */
export const requestShipmentTypes = [
  { code: 'fbo', label: 'FBO — поставки на склад маркетплейса' },
  { code: 'fbs', label: 'FBS — отгрузка заказов со склада фулфилмента' },
  { code: 'dbs', label: 'DBS — доставка покупателю силами продавца' },
] as const satisfies readonly { code: RequestApi.ShipmentType; label: string }[]

export const messengers = [
  { code: 'telegram', label: 'Telegram' },
  { code: 'whatsapp', label: 'WhatsApp' },
  { code: 'max', label: 'MAX' },
] as const satisfies readonly { code: RequestApi.Messenger; label: string }[]

/** Во что фулфилмент должен упаковать товар. */
export const packingTypes = [
  { code: 'box', label: 'Коробки' },
  { code: 'zip_bag', label: 'Zip-пакеты' },
  { code: 'other', label: 'Другое' },
] as const satisfies readonly { code: RequestApi.PackingType; label: string }[]

export const requestShipmentTypeLabels: Record<RequestApi.ShipmentType, string> = Object.fromEntries(
  requestShipmentTypes.map(({ code, label }) => [code, label])
) as Record<RequestApi.ShipmentType, string>

/**
 * Пометка состояния заявки для её автора. `null` — у одобренной заявки: она идёт своим ходом,
 * и пометка только отвлекала бы. `variant` — окраска плашки: `warning` там, где от продавца
 * ждут действия.
 */
export const requestStatusBadges = {
  pending: { label: 'На проверке', variant: 'info' },
  open: null,
  rejected: { label: 'Вернули на доработку', variant: 'warning' },
  closed: { label: 'Заявка закрыта', variant: 'secondary' },
} as const satisfies Record<RequestApi.Status, { label: string; variant: 'info' | 'warning' | 'secondary' } | null>
